import React from "react";
import { Play, Pause, SkipForward, Timer } from "@phosphor-icons/react";

function formatTime(s) {
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
}

/**
 * Fase de rest de la Live Session — timer regresivo con pausa y skip.
 * Extraído de LiveSession.jsx para aislarlo: el timer actualiza texto
 * cada segundo y era la zona más propensa a crashes de reconciliación
 * DOM con extensiones tipo Google Translate en Android.
 *
 * IMPORTANTE: el `<span>` alrededor del timer NO es cosmético — evita
 * que Chrome/Translate se quede con la referencia del text node bare.
 */
export default function LiveSessionRestPhase({
  phase,
  micro,
  macro,
  remaining,
  current,
  setIdx,
  totalSets,
  exercises,
  exIdx,
  paused,
  onTogglePause,
  onSkip,
}) {
  if (!current) return null;

  return (
    <div className="max-w-3xl mx-auto p-4 sm:p-8 h-full flex flex-col items-center justify-center text-center notranslate" translate="no">
      <div className="text-xs uppercase tracking-widest text-primary-app mb-4">
        {phase === "micro_rest" ? `Micro pausa · ${micro}s` : `Macro pausa · ${macro}s`}
      </div>
      <Timer size={72} weight="duotone" className="text-primary-app mb-6" />
      <div
        className="font-display font-black text-[8rem] sm:text-[12rem] leading-none tracking-tighter"
        style={{ color: remaining <= 3 ? "#FF3B30" : "#FFFFFF" }}
        data-testid="rest-timer"
      >
        <span>{formatTime(remaining)}</span>
      </div>
      <div className="text-muted text-sm mt-4 mb-8">
        {phase === "micro_rest"
          ? `Próxima serie: ${current.exercise_name} · Serie ${setIdx + 2} de ${totalSets}`
          : exercises[exIdx + 1]
          ? `Próximo: ${exercises[exIdx + 1].exercise_name}`
          : "Último ejercicio"}
      </div>
      <div className="flex gap-3">
        <button onClick={onTogglePause} className="btn-secondary flex items-center gap-2" data-testid="toggle-pause">
          {paused ? <Play size={18} weight="bold" /> : <Pause size={18} weight="bold" />}
          {paused ? "Reanudar" : "Pausa"}
        </button>
        <button onClick={onSkip} className="btn-primary flex items-center gap-2" data-testid="skip-rest">
          <SkipForward size={18} weight="bold" /> Saltar
        </button>
      </div>
    </div>
  );
}
